import MonthlyPeak from "./MonthlyPeak";
import DailyPeak from "./DailyPeak";

const Monthly = () => {
  return (
    <>
      <MonthlyPeak />
      <DailyPeak />
    </>
  );
};

export default Monthly;
